// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetPropertyResidents = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        residents: []

    }),

    /*
	**  Methods
    */
    
    methods: {

        getPropertyResidentsHandler: function(property_id) {

            try {

                propertiesModel.doc(property_id).collection('residents').where('meta.deleted_at', '==', null).get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Set the docs prop
                    **  @prop: @here
                    */

                    snapshot.forEach(doc => {

                        this.residents.push(doc.data());

                    });

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get Property Residents from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Residents',
                        uid: 'pGimvNnjJnRfbFOnXtyt',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query for a Property Residents from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Residents',
                    uid: 'YITl1NowOo4hvBGijXKM',
                    error: e
                });

            }

        }

    }

}